import React from 'react'
import { Box } from '@mui/material';
import HeaderTwo from '../../component/header/HeaderTwo';
import Breadcrumb from '../../component/common/Breadcrumb';
import Footer from '../../component/footer/Footer';
import FundiProfileTabs from '../../component/common/FundiProfileTabs';
import FundProfileSection from '../../element/section/FundProfileSection';

const FundiProfile = () => {
    return (
        <>
            <HeaderTwo />
            {/* Home > Job > Active Job */}
            <Breadcrumb parent='Home' title='Job' title1='Active Job' />
            <Box
                sx={{
                    width: '100%',
                    maxWidth: 1207,
                    margin: 'auto',
                    padding: '0',
                    backgroundColor: '#fff',
                    boxSizing: 'border-box',

                }}
            >
                <FundProfileSection/>
                <FundiProfileTabs/>
            </Box>
            <Footer/>
        </>

    )
}

export default FundiProfile;